import { render, staticRenderFns } from "./DeleteSite.vue?vue&type=template&id=c993151c"
import script from "./DeleteSite.vue?vue&type=script&lang=js"
export * from "./DeleteSite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports